/**
 * * Функция для копирования текста
 * @param text 
 */
export const copyToClipboard = async (text: string | number) => {
  try {
    await navigator.clipboard.writeText(text.toString());
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
};
